export default {
      id: "icon-phone-2-usage",
      viewBox: "0 0 28 28",
      url: "../icon/" + "icons.svg#icon-phone-2-usage",
      toString: function () {
        return this.url;
      }
    }